import React, { memo, useState } from "react";
import { Box, Container, Grid2, Stack, Typography } from "@mui/material";
import imgFindHome from "../../Assets/findHome.webp";
import imgClaimHome from "../../Assets/claimHome.webp";
import imgLockHome from "../../Assets/lockHome.webp";
import { ArrowForwardIos } from "@mui/icons-material";
import { RightPaddingWrapper } from "../../../../Components/RightPaddingWrapper/RightPaddingWrapper";
// Secure your home in three simple steps

const _textList = [
  {
    header: "Find It",
    subHeader: "Search by address and pull up your home from public records",
  },
  {
    header: "Claim It",
    subHeader: "Prove ownership with a single document upload",
  },
  {
    header: "Lock It",
    subHeader:
      "Unlock private home management — documents, maintenance & insurance",
  },
];
const _imageList = [
  imgFindHome,
  imgClaimHome,
  imgLockHome,
];
const PropertyInfo = memo(() => {
  const [textIndex, setTextIndex] = useState(0);
  return (
    <Container maxWidth={"xl"} disableGutters>
      <RightPaddingWrapper>
        <Box mt={15}>
          <Stack direction={"column"} spacing={"40px"}>
            <Box>
              <Typography fontWeight={"700"} variant="h3">
                Secure your home in{" "}
              </Typography>
              <Typography fontWeight={"700"} variant="h3">
                three simple steps
              </Typography>
            </Box>
            <Grid2 container>
              <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{order:{xs:2,md:1}}}>
                {_textList.map((v, i) => (
                  <Stack
                    key={i}
                    direction={"row"}
                    justifyContent={"space-between"}
                    // pr={10}
                    onClick={() => setTextIndex(i)}
                    sx={{ 
                      cursor: "pointer",
                      pr:{
                        sm:10
                      },
                      my:{
                        xs:7,
                        md:10
                      }
                    }}
                    // my={10}
                  >
                    <Stack direction={"row"}>
                      <Stack direction={"column"}>
                        <Box
                          color={textIndex === i ? "#04172d" : "text.disabled"}
                        >
                          <Typography fontWeight={"600"} variant="h4">
                            {v.header}
                          </Typography>
                          <Typography fontWeight={"500"} variant="subtitle1" fontSize={"1.05rem"} lineHeight={1.3} sx={{mt:{xs:'0.3rem',md:'0.6rem'}}}>
                            {v.subHeader}
                          </Typography>
                        </Box>
                      </Stack>
                    </Stack>
                    <Box>
                      {textIndex === i ? (
                        <Box
                          p={5}
                        //   borderRadius={60}
                        //   bgcolor={"white"}
                        //   height={60}
                        //   width={60}
                          alignItems={"center"}
                          justifyContent={"center"}
                          sx={{
                            cursor: "pointer",
                            // backdropFilter: "blur(5px)",
                            // boxShadow: 5,
                          }}
                          display={"flex"}
                        >
                          <ArrowForwardIos />
                        </Box>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Stack>
                ))}
              </Grid2>
              <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} sx={{order:{xs:1,md:2}}}>
                <img
                  src={_imageList[textIndex]}
                  alt={_textList[textIndex].header}
                  height={"100%"}
                  width={"100%"}
                  style={{
                    objectFit: "cover",
                    borderRadius: "20px",
                  }}
                />
              </Grid2>
            </Grid2>
          </Stack>
        </Box>
      </RightPaddingWrapper>
    </Container>
  );
});

export default PropertyInfo;
